export default "__VITE_ASSET__B0gL2qrD__"